import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Divider, Radio, Checkbox, Form, Button, Input, DatePicker } from 'antd';
import moment from 'moment';
import './styles.css';

import logo_sade_negro from '../../../../../images/logo_sade_negro.png';

const optionsPL01types = [
    { label: 'Agua Potable', value: 'Agua Potable' },
    { label: 'Desagües cloacales', value: 'Desagües cloacales' },
    { label: 'Gestión ambiental', value: 'Gestión ambiental' },
    { label: 'Service electrobombas', value: 'Service electrobombas' },
];

const optionsPL01toImprove = [
    { label: 'Institucional', value: 'Institucional' },
    { label: 'Comercial', value: 'Comercial' },
    { label: 'Técnico  Operativo', value: 'Técnico  Operativo' },
    { label: 'Mantenimiento preventivo y correctivo', value: 'Mantenimiento preventivo y correctivo' },
];

const optionsPL01calification = [
    { label: 'M', value: 'M' },
    { label: 'R', value: 'R' },
    { label: 'B', value: 'B' },
    { label: 'MB', value: 'MB' },
    { label: 'E', value: 'E' },
    { label: 'N/A', value: 'N/A' },
];

const PL01 = (props) => {
    const [form] = Form.useForm();
    const { surveyAssigned, userAssigned } = props;

    const handleSubmit = values => {
        props.onSubmit(values);
    }

    const handleReset = () => {
        form.resetFields()
    }

    return (
        <Grid className="PL01Cont">
            <div className="imageHeaderContPL01">
                <img className="imageHeaderPL01" src={logo_sade_negro} alt="Grupo SADE" />
            </div>
            <h1 className="titlePL01">Encuesta de satisfacción - Servicios de Asistencia Técnica</h1>
            <Row center="xs">
                <Col xs={0} md={1}></Col>
                <Col xs={6} md={4}>
                    <h3>Número de revisión:</h3><Input defaultValue="00" disabled/>
                </Col>
                <Col xs={0} md={2}></Col>
                <Col xs={6} md={4}>
                    <h3>Vigencia:</h3><Input defaultValue="Abril 2018" disabled/>
                </Col>
                <Col xs={0} md={1}></Col>
            </Row>
            <Divider type="horizontal" orientation="center">Encuesta informativa</Divider>
            <Row center="xs" end="md">
                <Col xs={12}>
                    <h3>Asignada el: {props.surveyAssigned ? moment(props.surveyAssigned.assignedDate, 'HH:mm DD/MM/YYYY').format('DD/MM/YYYY HH:mm') : "--/--/---- --:--"}</h3>
                </Col>
            </Row>
            <Form onFinish={handleSubmit} form={form} initialValues={{
                PL01_produced_by: "Gerente Técnico",
                PL01_approved_by: "Responsable del SGC",
                PL01_endorsed_by: "Dirección General"
            }}>
                <Row center="xs">
                    <Col xs={6}>
                        <DatePicker
                        placeholder="Fecha de realización"
                        format="DD/MM/YYYY HH:mm"
                        defaultValue={moment().utcOffset("-0300")}
                        showTime={{ defaultValue: moment('00:00', 'HH:mm') }}
                        disabled
                        />
                    </Col>
                </Row>

    {/* DEL PRESTADOR */}

                <Row start="xs">
                    <Col xs={12}>
                        <h3 className="sectionTitlePL01">I- Del prestador:</h3>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Nombre de Empresa, Comuna o Cooperativa:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_provider_name" rules={[{ required: true, message: 'Por favor, complete el nombre del prestador' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Localidad:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_provider_location" rules={[{ required: true, message: 'Por favor, complete la localidad del prestador' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Dirección:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_provider_direction" rules={[{ required: true, message: 'Por favor, complete la dirección del prestador' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>E-mail:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_provider_email" rules={[{ type: 'email', message: 'El correo no es válido' }, { required: true, message: 'Por favor, complete el e-mail del prestador' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Actividad/Servicio:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_provider_activity_service" rules={[{ required: true, message: 'Por favor, complete la activitdad / servicio del prestador' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col sm={12} md={4}>
                        <p className="labelContPL01">Servicio Asistencia Técnica contratado</p>
                    </Col>
                    <Col sm={12} md={8}>
                        <Form.Item name="PL01_types" rules={[{ required: true, message: 'Por favor, seleccione al menos un servicio' }]}>
                            <Checkbox.Group options={optionsPL01types} />
                        </Form.Item>
                    </Col>
                </Row>

    {/* DEL ENCUESTADO */}

                <Row start="xs">
                    <Col xs={12}>
                        <h3 className="sectionTitlePL01">II- Del encuestado:</h3>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Apellido y Nombre:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_user_full_name" rules={[{ required: true, message: 'Por favor, complete con apellido y nombre del encuestado' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Cargo que desempeña:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL01_user_position" rules={[{ required: true, message: 'Por favor, complete el cargo del encuestado' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>

    {/* DEL SERVICIO DE ASISTENCIA TECNICA */}

                <Row start="xs">
                    <Col xs={12}>
                        <h3 className="sectionTitlePL01">III- Del servicio de asistencia técnica:</h3>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col sm={12} md={4}>
                        <p className="labelContPL01">Respecto al(los) Servicios de Asistencia Técnica prestados, ¿En que aspectos sugiere trabajar para mejorarlos?</p>
                    </Col>
                    <Col sm={12} md={8}>
                        <Form.Item name="PL01_to_improve" rules={[{ required: true, message: 'Por favor, seleccione al menos una sugerencia' }]}>
                            <Checkbox.Group options={optionsPL01toImprove} />
                        </Form.Item>
                    </Col>
                </Row>
                <br />
                <h3>A su buen criterio, indique la calificación que corresponda para cada aspecto del servicio que se le presta</h3>
                <h4><span className="boldCont">M</span>: Malo | <span className="boldCont">R</span>: Regular | <span className="boldCont">B</span>: Bueno | <span className="boldCont">MB</span>: Muy Bueno | <span className="boldCont">E</span>: Excelente</h4>
                <div className="calificationsContPL01">
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Relación y trato del profesional con el prestador</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_01" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Preaviso de la visita del profesional a la localidad</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_02" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Puntualidad del profesional según corresponda</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_03" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Comunicación entre el profesional y el Prestador</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_04" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Tiempo de respuesta del profesional ante un pedido</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_05" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Predisposición a la resolución de problemas</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_06" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Cumplimiento en fecha de trabajos comprometidos</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_07" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Cumplimiento en forma de trabajos comprometidos</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_08" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Tiempo de respuesta ante requerimientos del ENTE Regulador/ Organismos Públicos</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_09" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Eficiencia del profesional en la capacitación del personal</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_10" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Eficiencia del profesional en la elaboración de notas y gestiones</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_11" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal"/>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL01">Cordialidad y espiritu servicial del profesional</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL01_calification_12" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL01calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <br />
                <Row className="rowInfoFooterPL01" center="xs">
                    <Col xs={6} className="infoFooterColPL01">
                        <Form.Item label="Elaborado por" name="PL01_produced_by" rules={[{ required: false, message: 'Por favor, complete el campo' }]}>
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col xs={6} className="infoFooterColPL01">
                        <Row>
                            <Col xs={12}>
                                <Form.Item label="Aprobado por" name="PL01_approved_by" rules={[{ required: false, message: 'Por favor, complete el campo' }]}>
                                    <Input disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Form.Item label="Visado por" name="PL01_endorsed_by" rules={[{ required: false, message: 'Por favor, complete el campo' }]}>
                                    <Input disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <br />
                <Row center="xs">
                    <Col xs={3} sm={3} md={3}></Col>
                    <Col xs={3} sm={3} md={3}>
                    {
                        props.isSaving ?
                            <Button type="primary" htmlType="submit" disabled={true} loading>
                                Enviar
                            </Button>
                            :
                            <Button type="primary" htmlType="submit" disabled={false}>
                                Enviar
                            </Button>
                    }
                    </Col>
                    <Col xs={3} sm={3} md={3}>
                        <Button onClick={handleReset}>
                            Limpiar
                        </Button>
                    </Col>
                    <Col xs={3} sm={3} md={3}></Col>
                </Row>
            </Form>
        </Grid>
    )
}

export default PL01;